import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || '',
  timeout: 15000,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getCDR = () => api.get('/api/cdr').then(response => response.data);
export const getCDROpportunities = (params = {}) => api.get('/api/cdr/opportunities', {
  params: Object.fromEntries(Object.entries(params).filter(([, value]) => value !== '' && value != null)),
  timeout: 30000,
}).then(response => response.data);
export const updateCDRSettings = settings => api.put('/api/cdr/settings', settings).then(response => response.data);
export const createCDROperation = operation => api.post('/api/cdr/operations', operation).then(response => response.data);
export const updateCDROperation = (id, operation) => api.patch(`/api/cdr/operations/${id}`, operation).then(response => response.data);
export const deleteCDROperation = id => api.delete(`/api/cdr/operations/${id}`).then(response => response.data);